import { getDimension } from '../utils';
import * as rows from '../rows';

// ----------------------------------------------------------------------------

function start(table: HTMLElement, config: Record<string, any> = {}): void {
    if (!(table instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    remove(table, config);
    add(table, config);
}

function add(table: HTMLElement, config: Record<string, any> = {}): void {
    if (!(table instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    const columns = table.querySelectorAll('td');
    const layouts = config.rowCount * config.columnCount;

    if (columns.length >= layouts) {
        return;
    }

    rows.count(table, config);
}

function remove(table: HTMLElement, config: Record<string, any> = {}): void {
    if (!(table instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    const columns = table.querySelectorAll('td');
    const layouts = config.rowCount * config.columnCount;

    if (columns.length <= layouts) {
        return;
    }

    for (let r = table.rows.length - 1; r >= 0; r--) {
        const elRow = table.rows[r];

        if (r >= config.rowCount) {
            removeRow(elRow, r, config);
        } else {
            removeColumns(elRow, r, config);
        }
    }
}

function removeRow(elRow: HTMLTableRowElement, rowIndex: number, config: Record<string, any> = {}): void {
    for (let c = elRow.cells.length - 1; c >= 0; c--) {
        const elColumn = elRow.cells[c];

        callRemovedColumn(elColumn, rowIndex, c, config);
        elColumn.remove();
    }

    if (typeof config.fnRemovedRow === 'function') {
        config.fnRemovedRow.call(elRow, {
            element: elRow,
            rowIndex: rowIndex,
        });
    }

    elRow.remove();
}

function removeColumns(elRow: HTMLTableRowElement, rowIndex: number, config: Record<string, any> = {}): void {
    for (let c = elRow.cells.length - 1; c >= 0; c--) {
        const elColumn = elRow.cells[c];

        if (c >= config.columnCount) {
            callRemovedColumn(elColumn, rowIndex, c, config);
            elColumn.remove();
        }
    }
}

function callRemovedColumn(
    elColumn: HTMLTableCellElement,
    rowIndex: number,
    columnIndex: number,
    config: Record<string, any> = {},
): void {
    if (typeof config.fnRemovedColumn === 'function') {
        config.fnRemovedColumn.call(elColumn, {
            element: elColumn,
            rowIndex: rowIndex,
            columnIndex: columnIndex,
        });
    }
}

function resize(element: HTMLElement): Record<string, any> {
    const dimension = getDimension(element);
    const listColumn = element.querySelectorAll('td');

    for (const column of listColumn) {
        column.style.width = dimension.width + 'px';
        column.style.height = dimension.height + 'px';
    }

    return {
        width: dimension.width,
        height: dimension.height,
    };
}

// ----------------------------------------------------------------------------

export { add, remove, resize, start };
